import React from 'react';
import PropTypes from 'prop-types';
import useAuthentication from '../hooks/useAuthentication';
import { getComponentDisplayName } from '../utils';

export const hasPrivilege = (userPrivileges, sufficientPrivileges) => userPrivileges.some((userPrivilege) => sufficientPrivileges.includes(userPrivilege));

Privileged.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.node,
};

Privileged.defaultProps = {
    children: null,
};

export function Privileged(props) {
    const { children, sufficientPrivileges } = props;
    const { userPrivileges } = useAuthentication();
    return (
        hasPrivilege(userPrivileges, sufficientPrivileges) && children
    );
}

const withPrivileges = (sufficientPrivileges) => (WrappedComponent) => {

    const WithPrivileges = (props) => {
        const { userPrivileges } = useAuthentication();
        return (
            hasPrivilege(userPrivileges, sufficientPrivileges) && <WrappedComponent {...props} />
        );
    };

    WithPrivileges.displayName = `WithPrivileges(${getComponentDisplayName(WrappedComponent)})`;

    return WithPrivileges;

};

export default withPrivileges;
